
import ApexCharts from './apexcharts'

const 
_primary = "#5A8DEE",
_success = "#39DA8A",
_danger = "#FF5B5C",
_warning = "#FDAC41",
_info = "#00CFDD",
_secondary = "#828D99",
_secondary_light = "#e7edf3",
_light_primary = "#E2ECFF",
_label_color = "#475f7b",
_primary_light = "#E2ECFF",
_danger_light = "#ffeed9",
_gray_light = "#828D99",
_sub_label_color = "#596778",
_radial_bg = "#e7edf3"

/*----------------------------------------------------------------------------*/
// Order Summary Chart
export const OrderSummary = ($this, dataset) => {
  const OSOptions = {
    chart: {
      height: 270,
      type: "line",
      stacked: false,
      toolbar: { show: false },
      sparkline: { enabled: true },
    },
    colors: [_primary, _primary],
    dataLabels: { enabled: false },
    stroke: {
      curve: "smooth",
      width: 2.5,
      dashArray: [0, 8],
    },
    fill: {
      type: "gradient",
      gradient: {
        inverseColors: false,
        shade: "light",
        type: "vertical",
        gradientToColors: [_light_primary, _primary],
        opacityFrom: 0.7,
        opacityTo: 0.55,
        stops: [0, 80, 100],
      },
    },
    series: [
      {
        name: "Weeks",
        data: [165, 175, 162, 173, 160, 195, 160, 170, 160, 190, 180],
        type: "area",
      },
      {
        name: "Months",
        data: [168, 168, 155, 178, 155, 170, 190, 160, 150, 170, 140],
        type: "line",
      },
    ],
    xaxis: {
      offsetY: -50,
      categories: ["", 1, 2, 3, 4, 5, 6, 7, 8, 9, ""],
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: {
        show: true,
        style: { colors: _secondary },
      },
    },
    tooltip: {
      x: { show: false },
    },
  },
  OSChart = new ApexCharts($this.find("#order-summary-chart")[0], OSOptions);

  OSChart.render();
}

/*----------------------------------------------------------------------------*/
// Yearly Trafic Analytics Chart
export const YealyTraffic = ($this, dataset) => {
  // Customers
  const TCOptions = {
      chart: {
        height: 40,
        width: 40,
        type: "radialBar",
      },
      grid: {
        show: false,
        padding: {
          left: -30,
          right: -30,
          top: 0,
        },
      },
      series: [30],
      colors: [_success],
      plotOptions: {
        radialBar: {
          hollow: { size: "30%" },
          dataLabels: {
            showOn: "always",
            name: { show: false },
            value: { show: false },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          gradientToColors: [_success],
          opacityFrom: 1,
          opacityTo: 0.8,
          stops: [0, 70, 100],
        },
      },
      stroke: { lineCap: "round" },
    },
    TCChart = new ApexCharts(
      $this.find("#trafic-customers-chart")[0],
      TCOptions
    );

  TCChart.render();

  // Sessions
  const TSOptions = {
      chart: {
        height: 40,
        width: 40,
        type: "radialBar",
      },
      grid: {
        show: false,
        padding: {
          left: -30,
          right: -30,
          top: 0,
        },
      },
      series: [80],
      colors: [_warning],
      plotOptions: {
        radialBar: {
          hollow: { size: "30%" },
          dataLabels: {
            showOn: "always",
            name: { show: false },
            value: { show: false },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          gradientToColors: [_warning],
          opacityFrom: 1,
          opacityTo: 0.8,
          stops: [0, 70, 100],
        },
      },
      stroke: { lineCap: "round" },
    },
    TSChart = new ApexCharts(
      $this.find("#trafic-sessions-chart")[0],
      TSOptions
    );

  TSChart.render();

  // Bounce Rate
  const TBROptions = {
      chart: {
        height: 40,
        width: 40,
        type: "radialBar",
      },
      grid: {
        show: false,
        padding: {
          left: -30,
          right: -30,
          top: 0,
        },
      },
      series: [50],
      colors: [_danger],
      plotOptions: {
        radialBar: {
          hollow: { size: "30%" },
          dataLabels: {
            showOn: "always",
            name: { show: false },
            value: { show: false },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          gradientToColors: [_danger],
          opacityFrom: 1,
          opacityTo: 0.8,
          stops: [0, 70, 100],
        },
      },
      stroke: { lineCap: "round" },
    },
    TBRChart = new ApexCharts(
      $this.find("#trafic-bounce-rate-chart")[0],
      TBROptions
    );

  TBRChart.render();

  // Main Chart
  const YTAOptions = {
      chart: {
        height: 260,
        type: "bar",
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "20%",
          endingShape: "rounded",
        },
      },
      legend: {
        horizontalAlign: "right",
        offsetY: -10,
        markers: {
          radius: 50,
          height: 8,
          width: 8,
        },
      },
      dataLabels: { enabled: false },
      colors: [_primary, _primary_light],
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "vertical",
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 70, 100],
        },
      },
      series: [
        {
          name: "2020",
          data: [80, 95, 150, 210, 140, 230, 300, 280, 130],
        },
        {
          name: "2019",
          data: [50, 70, 130, 180, 90, 180, 270, 220, 110],
        },
      ],
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
        ],
        axisBorder: { show: false },
        axisTicks: { show: false },
        labels: {
          style: { colors: _gray_light },
        },
      },
      yaxis: {
        min: 0,
        max: 300,
        tickAmount: 3,
        labels: {
          style: { color: _gray_light },
        },
      },
      legend: { show: false },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$ " + val + " thousands";
          },
        },
      },
    },
    YTAChart = new ApexCharts(
      $this.find("#yearly-trafic-analytics-chart")[0],
      YTAOptions
    );

  YTAChart.render();
}

/*----------------------------------------------------------------------------*/
// Resellers Income Chart
export const ResalersIncome = ($this, dataset) => {
  const RIOptions = {
      chart: {
        height: 40,
        type: "line",
        toolbar: { show: false },
        sparkline: { enabled: true },
      },
      grid: {
        show: false,
        padding: {
          bottom: 5,
          top: 5,
          left: 10,
          right: 0,
        },
      },
      colors: [_primary],
      dataLabels: { enabled: false },
      stroke: { width: 3, curve: "smooth" },
      series: [
        {
          data: [50, 100, 0, 60, 20, 30],
        },
      ],
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          gradientToColors: [_primary],
          opacityFrom: 0,
          opacityTo: 0.9,
          stops: [0, 30, 70, 100],
        },
      },
      xaxis: {
        show: false,
        labels: { show: false },
        axisBorder: { show: false },
      },
      yaxis: { show: false },
    },
    RIChart = new ApexCharts(
      $this.find("#resellers-income-chart")[0],
      RIOptions
    );

  RIChart.render();
}

/*----------------------------------------------------------------------------*/
// Customer Income Chart
export const CustomerIncome = ($this, dataset) => {
  const CICOptions = {
      chart: {
        height: 40,
        type: "line",
        toolbar: { show: false },
        sparkline: { enabled: true },
      },
      grid: {
        show: false,
        padding: {
          bottom: 5,
          top: 5,
          left: 10,
          right: 0,
        },
      },
      colors: [_success],
      dataLabels: { enabled: false },
      stroke: { width: 3, curve: "smooth" },
      series: [{ data: [30, 60, 30, 80, 20, 70] }],
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          gradientToColors: [_success],
          opacityFrom: 0,
          opacityTo: 0.9,
          stops: [0, 30, 70, 100],
        },
      },
      xaxis: {
        show: false,
        labels: { show: false },
        axisBorder: { show: false },
      },
      yaxis: { show: false },
    },
    CIChart = new ApexCharts(
      $this.find("#customers-income-chart")[0],
      CICOptions
    );

  CIChart.render();
}

/*----------------------------------------------------------------------------*/
// Profit Reports Chart (Last & Current Years)
export const ProfitReport = ($this, dataset) => {
  const PLROptions = {
      chart: {
        height: 40,
        width: 40,
        type: "radialBar",
        sparkline: { show: true },
      },
      grid: {
        show: false,
        padding: {
          left: -30,
          right: -30,
          top: 0,
          bottom: -70,
        },
      },
      series: [50],
      colors: [_primary],
      plotOptions: {
        radialBar: {
          hollow: { size: "30%" },
          dataLabels: {
            showOn: "always",
            name: { show: false },
            value: { show: false },
          },
        },
      },
      stroke: { lineCap: "round" },
    },
    PCROptions = {
      chart: {
        height: 40,
        width: 40,
        type: "radialBar",
        sparkline: { show: true },
      },
      grid: {
        show: false,
        padding: {
          left: -30,
          right: -30,
          top: 0,
          bottom: -70,
        },
      },
      series: [70],
      colors: [_info],
      plotOptions: {
        radialBar: {
          hollow: { size: "30%" },
          dataLabels: {
            showOn: "always",
            name: { show: false },
            value: { show: false },
          },
        },
      },
      stroke: { lineCap: "round" },
    },
    PLRChart = new ApexCharts(
      $this.find("#profile-last-report-chart")[0],
      PLROptions
    ),
    PCRChart = new ApexCharts(
      $this.find("#profile-current-report-chart")[0],
      PCROptions
    );

  PLRChart.render();
  PCRChart.render();
}

/*----------------------------------------------------------------------------*/
// Referrals Chart
export const Referrals = ($this, dataset) => {
  const ROptions = {
      chart: {
        type: "bar",
        height: 60,
        width: 120,
        sparkline: { enabled: true },
        toolbar: { show: false },
      },
      states: {
        hover: { filter: "none" },
      },
      colors: [
        _primary_light,
        _primary_light,
        _primary_light,
        _primary_light,
        _primary,
        _primary_light,
      ],
      series: [
        {
          name: "Sessions",
          data: [3, 7, 5, 15, 9, 8, 12],
        },
      ],
      grid: {
        show: false,
        padding: { left: 0, right: 0 },
      },
      plotOptions: {
        bar: { columnWidth: "80%", distributed: true },
      },
      tooltip: {
        x: { show: false },
      },
      xaxis: { type: "numeric" },
    },
    RChart = new ApexCharts($this.find("#referrals-chart")[0], ROptions);

  RChart.render();
}

/*----------------------------------------------------------------------------*/
// Weekly sales Chart
export const WeeklySales = ($this, dataset) => {
  const WSOptions = {
      chart: {
        height: 100,
        type: "bar",
        stacked: true,
        toolbar: { show: false },
      },
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0,
          top: -20,
          bottom: -15,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "20%",
          endingShape: "rounded",
        },
      },
      legend: { show: false },
      dataLabels: { enabled: false },
      colors: [_primary, _primary_light],
      series: [
        {
          name: "2020",
          data: [80, 40, 30, 90, 20, 50, 95],
        },
        {
          name: "2019",
          data: [20, 60, 70, 10, 80, 50, 5],
        },
      ],
      xaxis: {
        categories: ["S", "M", "T", "W", "T", "F", "S"],
        axisBorder: { show: false },
        axisTicks: { show: false },
        labels: {
          style: { colors: _gray_light },
          offsetY: -5,
        },
      },
      yaxis: { show: false, floating: true },
      tooltip: {
        x: { show: false },
      },
    },
    WSChart = new ApexCharts($this.find("#weekly-sales-chart")[0], WSOptions);

  WSChart.render();
}

/*----------------------------------------------------------------------------*/
// Business Growth Chart
export const BusinessGrowth = ($this, dataset) => {
  const BGOptions = {
      chart: {
        height: 200,
        type: "radialBar",
        sparkline: { show: true },
      },
      grid: { show: false },
      plotOptions: {
        radialBar: {
          size: 100,
          startAngle: -135,
          endAngle: 135,
          offsetY: 40,
          hollow: { size: "60%" },
          track: { strokeWidth: "90%", background: "#fff" },
          dataLabels: {
            value: {
              offsetY: -10,
              color: "#475f7b",
              fontSize: "26px",
            },
            name: {
              fontSize: "15px",
              color: "#596778",
              offsetY: 30,
            },
          },
        },
      },
      colors: [_success],
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          shadeIntensity: 0.5,
          gradientToColors: [_primary],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      stroke: { dashArray: 3 },
      series: [78],
      labels: ["Growth"],
    },
    BGChart = new ApexCharts(
      $this.find("#business-growth-chart")[0],
      BGOptions
    );

  BGChart.render();
}

/*----------------------------------------------------------------------------*/
// Revenue Growth chart
export const RevenueGrowth = ($this, dataset) => {
  const RGOptions = {
      chart: {
        height: 100,
        type: "bar",
        stacked: true,
        toolbar: { show: false },
      },
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0,
          top: -20,
          bottom: -15,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "20%",
          endingShape: "rounded",
        },
      },
      legend: { show: false },
      dataLabels: { enabled: false },
      colors: [_info, _secondary_light],
      series: [
        {
          name: "2020",
          data: [
            50, 70, 100, 120, 140, 100, 70, 80, 90, 110, 50, 70, 35, 110, 100,
            105, 125, 80,
          ],
        },
        {
          name: "2019",
          data: [
            70, 50, 20, 30, 20, 90, 90, 60, 50, 0, 50, 60, 140, 50, 20, 20, 10,
            0,
          ],
        },
      ],
      xaxis: {
        categories: [
          "0",
          "",
          "",
          "",
          "",
          "10",
          "",
          "",
          "",
          "",
          "",
          "15",
          "",
          "",
          "",
          "",
          "",
          "20",
        ],
        axisBorder: { show: false },
        axisTicks: { show: false },
        labels: {
          style: { colors: _secondary },
          offsetY: -5,
        },
      },
      yaxis: { show: false, floating: true },
      tooltip: {
        x: { show: false },
      },
    },
    RGChart = new ApexCharts($this.find("#revenue-growth-chart")[0], RGOptions);

  RGChart.render();
}

/*----------------------------------------------------------------------------*/
// Impression Report Chart
export const ImpressionReport = ($this, dataset) => {
  const IROptions = {
      chart: { width: 300, type: "donut" },
      dataLabels: { enabled: false },
      series: [470, 257, 877, 792],
      labels: ["Search", "Marketing", "Services", "Products"],
      stroke: { width: 4, lineCap: "round" },
      colors: [_primary, _danger, _warning, _success],
      plotOptions: {
        pie: {
          donut: {
            size: "90%",
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: "15px",
                colors: _sub_label_color,
                offsetY: 20,
                fontFamily: "IBM Plex Sans",
              },
              value: {
                show: true,
                fontSize: "26px",
                fontFamily: "Rubik",
                color: _label_color,
                offsetY: -20,
              },
              total: {
                show: true,
                label: "Total Feeds",
                color: _gray_light,
                formatter: function (w) {
                  return w.globals.seriesTotals.reduce(function (a, b) {
                    return a + b;
                  }, 0);
                },
              },
            },
          },
        },
      },
      legend: { show: false },
    },
    IRChart = new ApexCharts(
      $this.find("#impression-report-chart")[0],
      IROptions
    );

  IRChart.render();
}

/*----------------------------------------------------------------------------*/
// User Subscriptions
export const Subscription = ($this, dataset) => {
  const USOptions = {
      chart: { height: 300, type: "radialBar" },
      colors: [_primary, _danger, _info],
      series: [95, 48, 68],
      plotOptions: {
        radialBar: {
          offsetY: 10,
          hollow: { size: "45%" },
          track: { margin: 10, background: "none" },
          dataLabels: {
            name: {
              fontSize: "15px",
              color: [_secondary],
              fontFamily: "IBM Plex Sans",
              offsetY: 25,
            },
            value: {
              fontSize: "30px",
              fontFamily: "Rubik",
              offsetY: -15,
            },
            total: {
              show: true,
              label: "Total Avg.",
              color: _secondary,
              formatter: function (w) {
                return (
                  (
                    w.globals.seriesTotals.reduce(function (a, b) {
                      return a + b;
                    }, 0) / w.globals.seriesTotals.length
                  ).toFixed(1) + "%"
                );
              },
            },
          },
        },
      },
      stroke: { lineCap: "round" },
      labels: ["VendOne", "Marketing", "Warehouse"],
    },
    USChart = new ApexCharts(
      $this.find("#user-subscriptions-chart")[0],
      USOptions
    );

  USChart.render();
}
